import React, { createContext, useCallback, useContext, useState } from 'react';

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);

    const push = useCallback((toast) => {
        const id = Math.random().toString(36).slice(2);
        const t = { id, duration: 4500, variant: 'amber', ...toast };
        setToasts((arr) => [...arr, t]);
        setTimeout(() => setToasts((arr) => arr.filter((x) => x.id !== id)), t.duration);
    }, []);

    return (
        <ToastCtx.Provider value={{ push }}>
            {children}
            <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 360 }}>
                {toasts.map((t) => (
                    <div key={t.id} className={`toast toast-${t.variant} slide-in-right`} data-testid="toast">
                        {t.title && <div style={{ fontWeight: 600, marginBottom: 2 }}>{t.title}</div>}
                        <div style={{ fontSize: '0.92rem', color: '#d4d4d4' }}>{t.message}</div>
                    </div>
                ))}
            </div>
        </ToastCtx.Provider>
    );
}

export const useToast = () => useContext(ToastCtx);
